export default __webpack_public_path__ + "static/media/justina.564b390f.jpg";